module.exports = __webpack_public_path__ + "img/achievement5.d6db18fd.jpeg";